import React from 'react';
import PropTypes from 'prop-types';
import ActivationIndicatorIcon from './ActivationIndicatorIcon';

var ActivationIndicator = function ActivationIndicator(_ref) {
  var classes = _ref.classes,
      density = _ref.density,
      enabled = _ref.enabled,
      validationState = _ref.validationState,
      hasIcon = _ref.hasIcon;
  return enabled ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.activationIndicator
  }), validationState && hasIcon && /*#__PURE__*/React.createElement(ActivationIndicatorIcon, {
    className: classes.activationIndicatorIcon,
    density: density,
    validationState: validationState
  })) : null;
};

process.env.NODE_ENV !== "production" ? ActivationIndicator.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  density: PropTypes.oneOf(['touch', 'low', 'medium', 'high']),
  enabled: PropTypes.bool,
  hasIcon: PropTypes.bool,

  /**
   * Error state string: 'warning', 'error' or '' (default)
   */
  validationState: PropTypes.oneOf(['warning', 'error', ''])
} : void 0;
export default ActivationIndicator;